<template>
  <div class="app-container">
    <el-container>
      <el-header>
        <div class="header-container">
          <div class="logo">
            <router-link to="/">互联网联合辟谣平台</router-link>
          </div>
          <el-menu
            :default-active="activeIndex"
            class="main-menu"
            mode="horizontal"
            router
            background-color="#409EFF"
            text-color="#fff"
            active-text-color="#ffd04b"
          >
            <el-menu-item index="/">首页</el-menu-item>
            <el-menu-item index="/rumors">谣言辟谣</el-menu-item>
            <el-menu-item index="/knowledge">联动要闻</el-menu-item>
            <el-menu-item index="/laws">法律政策</el-menu-item>
            <el-menu-item index="/naws">热点专题</el-menu-item>
            <el-menu-item index="/WorkList">工作动态</el-menu-item>
          </el-menu>
          <div class="user-actions">
            <template v-if="isAuthenticated">
              <el-dropdown>
                <span class="el-dropdown-link">
                  {{ currentUser.username }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item>
                      <router-link to="/profile">个人中心</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item @click="handleLogout">退出登录</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </template>
            <template v-else>
              <router-link to="/login" class="login-btn">登录</router-link>
              <router-link to="/register" class="register-btn">注册</router-link>
            </template>
          </div>
        </div>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <el-footer>
        <div class="footer-content">
          <p>© 2025 互联网联合辟谣平台 - 违法和不良信息举报中心@版权所有</p>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'

export default {
  name: 'App',
  setup() {
    const store = useStore()
    const router = useRouter()
    const route = useRoute()
    
    const activeIndex = computed(() => route.path)
    const isAuthenticated = computed(() => store.getters.isAuthenticated)
    const currentUser = computed(() => store.getters.currentUser)
    
    const handleLogout = () => {
      store.dispatch('logout')
      router.push('/login')
    }
    
    return {
      activeIndex,
      isAuthenticated,
      currentUser,
      handleLogout
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.app-container {
  min-height: 100vh;
}

.el-header {
  padding: 0;
  background-color: #409EFF;
  color: #fff;
  line-height: 60px;
}

.header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
}

.logo {
  font-size: 20px;
  font-weight: bold;
}

.logo a {
  color: #fff;
  text-decoration: none;
}

.main-menu {
  flex: 1;
  margin-left: 30px;
  border-bottom: none;
}

.user-actions {
  display: flex;
  align-items: center;
}

.login-btn, .register-btn {
  margin-left: 15px;
  color: #fff;
  text-decoration: none;
}

.el-dropdown-link {
  color: #fff;
  cursor: pointer;
}

.el-main {
  padding: 20px;
  min-height: calc(100vh - 120px);
}

.el-footer {
  height: 60px !important;
  background-color: #f5f7fa;
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer-content {
  text-align: center;
  color: #909399;
}
</style>
